import { DateFilter } from '../../interfaces/filters/date.filter';
import { InterestsEnum, PrivacyTypesEnum, LocationSearchModeEnum, EventIntegrationTypeEnum } from '../../enums';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { SearchFilter } from '../../interfaces/filters/search.filter';
import { arrayOrStringToArray, jsonStringToObject } from '../../types-transformers';
import { Transform } from 'class-transformer';
import { IsOptional, IsUUID, IsEnum } from 'class-validator';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { EventInstanceDto } from '../dto';

export type EventPeriodFilter = [Date, Date?];

export class EventFitnessTypesFilter {
	public id: InterestsEnum;
	public masteryLevels?: number[] | null;
	public exclude?: boolean;
}

export enum EventInstanceSortEnum {
	InstanceAsc = 'instance',
	InstanceDesc = 'instance-desc',
	DistanceAsc = 'distance',
	BaseIdsListAsc = 'base-ids-list-asc',
	InstanceIdsListAsc = 'instance-ids-list-asc',
	CreatedAtDesc = 'created-at-desc',
}

export class EventFilter extends DateFilter {
	public enableShapedAiRanking?: boolean;
	public enableShapedAiRankingV2?: boolean;
	public ignoreShapedAiUserPreferences?: boolean;
	public useShapedAiUpdatedForYouRanking?: boolean;
	public hideEmptyAvatars?: boolean;
	public withCanceledForUserId?: string;
	public withDrafts?: boolean;
	public includeParticipants?: boolean;
	public orderedEventBaseIds?: string[];
	@IsOptional()
  @IsUUID(4, { each: true })
  public eventIds?: string[];
	public excludedEventIds?: string[];
	public orderedEventInstanceIds?: string[];
	public eventInstanceIds?: string[];
	public excludedEventInstanceIds?: string[];
	public eventAliases?: string[];
	public creatorsIds?: string[];
	public attendeesIds?: string[];
	public excludedCreatorsIds?: string[];
	public search?: string;
	public fitnessTypes?: Array<EventFitnessTypesFilter>;
	public paid?: boolean | null;
	public isDonationBased?: boolean | null;
	public online?: boolean | null;
	public costGte?: number;
	public costLte?: number;
	public customPeriods?: EventPeriodFilter[];
	public minDistance?: number;
	public maxDistance?: number;
	public userLat?: number;
	public userLng?: number;
	public sort?: EventInstanceSortEnum;
	public limit?: number;
	public offset?: number;
	public page?: number;
	public disablePrivacyFilteringForAdmins?: boolean;
	public onlyBusinessAuthors?: boolean;

	/** only events which are participated by users which are 'mutual accepted subscriptions' (sweat pals) of current-user */
	public onlyEventsParticipatedBySweatPals?: boolean;

	/** only events participated by users which are subscriptions (any, not only mutual or accepted) of current-user  */
	public onlyEventsParticipatedBySubscriptions?: boolean;

	/** only events authored by current-user subscriptions */
	public onlySubscriptions?: boolean;
	public includeSubscriptionParticipants?: boolean;
	public eventsParticipatedByBusinessAccounts?: boolean;
	public countryId?: string;
	public stateId?: string;
	public cityId?: string;
	public citySearchMode?: LocationSearchModeEnum;
	public includeRevenueForHost?: boolean;
	public includeDiscountsForHost?: boolean;
	public createdAfter?: Date;
	public createdBefore?: Date;
	public isEditorPick?: boolean;
	public isSweatSchedule?: boolean;
	public privacyIds?: PrivacyTypesEnum[];
	public includeMembershipCalculations?: boolean;
	public withUnverifiedEvents?: boolean;
	public onlyUnverifiedEvents?: boolean;

	@IsOptional()
	@Transform(arrayOrStringToArray)
	@IsEnum(EventIntegrationTypeEnum, { each: true })
	public onlyWithoutIntegrations?: EventIntegrationTypeEnum[];

	@IsOptional()
	@Transform(arrayOrStringToArray)
	@IsEnum(EventIntegrationTypeEnum, { each: true })
	public onlyWithIntegrations?: EventIntegrationTypeEnum[];
}

export class EventInstanceFilter extends EventFilter {
	// don't use with "periodFrom/periodTo" + "lastEventId" since sorting is still using "instance" column
	// use "page" + "limit" instead
	public filterByEndDate?: boolean;
	public lastEventId?: string;
	public maxEventsPerAuthorPerDay?: number;
	public oneInstancePerEvent?: boolean;
	public shortLocalInstances?: string[];

	public includeEventTicketsCount?: boolean;
	public includeEventPricesTicketsCount?: boolean;

	public isAllowedToPublishToOtherPlatforms?: boolean;

	public maxSelectedParticipantsPerEvent?: number;
	public includeHostsCoHostsToParticipantsList?: boolean;
}

export class FavouriteEventInstanceFilter extends EventInstanceFilter {
	@Transform(jsonStringToObject)
	@IsOptional()
	public orderedBy?: OrderParamPair<EventInstanceDto>[] | null;
}

export class EventCategoriesFilter extends PaginationFilter {
	stateId?: string;
	cityId?: string;
}

export class EventOptionsFilter implements SearchFilter, PaginationFilter {
	public communityId?: string;

	public eventId?: string;
	public alias?: string;

	@IsOptional()
	@Transform(arrayOrStringToArray)
	@IsUUID('4', { each: true })
	public privacyIds?: PrivacyTypesEnum[];

	public search?: string;

	public page?: number | null;
	public pageSize?: number | null;
}
